import { render, staticRenderFns } from "./Acknowledged.vue?vue&type=template&id=d234b82c&scoped=true&"
import script from "./Acknowledged.vue?vue&type=script&lang=js&"
export * from "./Acknowledged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d234b82c",
  null
  
)

export default component.exports